import { render, staticRenderFns } from "./RateServices.vue?vue&type=template&id=d7487258&scoped=true&"
import script from "./RateServices.vue?vue&type=script&setup=true&lang=js&"
export * from "./RateServices.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RateServices.vue?vue&type=style&index=0&id=d7487258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7487258",
  null
  
)

export default component.exports